module.exports = __webpack_public_path__ + "static/work49-8c6c86bd630ceda8f706aa9134e2ed30.jpg";